import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import { getReceipt } from "./requests";
import { INTERNAL_PATHS } from "routes/paths";
import { useShowSnackbar } from "hooks/useShowSnackbar";
import { useNavigate } from "hooks/useCustomNavigation";
import { NOTIFICATION_MESSAGES } from "./constants";

export const useGetOrder = () => {
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(null);
  const params = useParams();
  const navigate = useNavigate();
  const { addNotification } = useShowSnackbar();

  const handleNotFound = useCallback(() => {
    addNotification({
      variant: "error",
      persist: true,
      message: NOTIFICATION_MESSAGES.order_not_found
    });
    navigate(INTERNAL_PATHS.MY_ORDERS);
  }, [addNotification, navigate]);

  const getOrderAndSaveIfExists = useCallback(async () => {
    setLoading(true);
    const orderNumber = params?.orderId;
    if (!orderNumber) {
      handleNotFound();
      return;
    }

    try {
      const response = await getReceipt({ orderNumber });
      if (!response) {
        handleNotFound();
        return;
      }
      setOrder(response.data);
    } catch (error) {
      handleNotFound();
    } finally {
      setLoading(false);
    }
  }, [params?.orderId, handleNotFound]);

  useEffect(() => {
    void getOrderAndSaveIfExists();
  }, [getOrderAndSaveIfExists]);

  return {
    loading,
    order
  };
};
